import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid gap-x-4 grid-cols-2"
}
const _hoisted_2 = { class: "grid gap-y-2 mb-2" }
const _hoisted_3 = { class: "flex justify-around mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiCardDivider = _resolveComponent("UiCardDivider")!
  const _component_UiRadioTabs = _resolveComponent("UiRadioTabs")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiCheckbox = _resolveComponent("UiCheckbox")!
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiForm = _resolveComponent("UiForm")!
  const _component_ElDialog = _resolveComponent("ElDialog")!

  return (_openBlock(), _createBlock(_component_ElDialog, {
    onClosed: _ctx.closeDialog,
    customClass: "is-confirmation",
    modelValue: _ctx.isOpened,
    destroyOnClose: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_UiForm, { onSubmit: _ctx.submit }, {
        default: _withCtx(() => [
          _createVNode(_component_UiCardDivider, { title: "Set schedule for the day" }),
          _createVNode(_component_UiRadioTabs, {
            modelValue: _ctx.formData.openState,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.openState) = $event)),
            name: "openState",
            options: [
					{
						title: 'Open all day',
						value: _ctx.OpenState.open
					},
					{
						title: 'Closed all day',
						value: _ctx.OpenState.closed
					},
					{
						title: 'Custom schedule',
						value: _ctx.OpenState.custom
					}
				]
          }, null, 8, ["modelValue", "options"]),
          (
					_ctx.formData.openState === _ctx.OpenState.custom
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_UiInput, {
                  placeholder: "8:00am",
                  name: "from",
                  label: "From",
                  modelValue: _ctx.formData.from,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.from) = $event)),
                  type: "time"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_UiInput, {
                  placeholder: "8:00pm",
                  name: "to",
                  label: "To",
                  modelValue: _ctx.formData.to,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.to) = $event)),
                  type: "time"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_UiCheckbox, {
              modelValue: _ctx.applyToOtherDays,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.applyToOtherDays) = $event)),
              label: "Apply to other days",
              name: "applyToOtherDays"
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.applyToOtherDays)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_UiCardDivider),
                _createElementVNode("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (day) => {
                    return (_openBlock(), _createBlock(_component_UiCheckbox, {
                      "onUpdate:modelValue": ($event: any) => (
							_ctx.toggleDay(day.id)
						),
                      modelValue: _ctx.isSelected(day.id),
                      key: day.id,
                      class: "!mb-0",
                      label: _ctx.getDay(day),
                      name: _ctx.getDay(day)
                    }, null, 8, ["onUpdate:modelValue", "modelValue", "label", "name"]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_UiButton, {
              onClick: _ctx.closeDialog,
              theme: "primary-outlined",
              type: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_UiButton, null, {
              default: _withCtx(() => [
                _createTextVNode("Apply")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["onClosed", "modelValue"]))
}